import axios from 'axios'
import { castAttributesForCamelCase, castAttributesForSnakeCase } from '../../../modules/string_converter'
import { i18n } from '../../../plugins/i18n'

/**
 * @typedef Question
 * @type { object }
 * @property { number } id
 * @property { string } name
 * @property { 'radio' | 'checkbox' | 'nps' } type
 * @property { number } position
 * @property { ?Option[] } options
 *
 */

/**
 * @typedef Option
 * @property { string } id
 * @property { string } name
 */

/**
 * fieldと呼んでいる、分析軸とクロス分析軸周りで取り回しているオブジェクト
 * @typedef AnalysisField
 * @property { number } id
 * @property { 'store_id' | 'site_type' | 'brand_id' |'franchisee_id' | 'user_company_id' | 'prefecture' | 'area_id' } key
 * @property { string } name
 */

export const companiesAnalysisSurveys = {
  namespaced: true,
  state: {
    data: [],
    meta: null,
    loading: false,
  },
  getters: {
    /**
     * @param state
     * @param getters
     * @return {[{name: string, id: string}, ...Question]}
     */
    questionsForTable(state, getters) {
      const arr = [
        {
          id: 'answersCount',
          name: i18n.t('models.survey.answeredCount')
        }
      ]
      return arr.concat(getters.displayQuestions)
    },
    displayQuestions(state) {
      return state.meta ? state.meta.questions : []
    }
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readAnalysisCustomSurveySuccess(state, payload) {
      state.data = payload.data.map(v => {
        const tmpData = castAttributesForCamelCase(v)
        tmpData.id = tmpData.fields.map(field => field.key + '-' + field.id).join('|')
        return tmpData
      })
      state.meta = payload.meta
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    }
  },
  actions: {
    readAnalysisCustomSurvey({ commit, rootState }, { query, id }) {
      commit('prepareConnect')

      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/analysis/custom_surveys/' + id + '/aggregates' + '.json', {
          params: {
            ...castAttributesForSnakeCase(query),
          }
        })
        .then(res => {
          commit('readAnalysisCustomSurveySuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    exportCsv({ commit, rootState }, { query, id }) {
      commit('prepareConnect')

      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/export/analysis/custom_surveys/${id}/aggregates.json`, castAttributesForSnakeCase(query))
        .then(() => {
          commit('stopLoading')
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    }
  }
}
